/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Added by Bruno B @ Shopify - May 4 2021 
var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.$container = $(this.container);
    this.speed = $('.slideshow__slides', this.$container).data('slideshow-transition-time');
    this.autoPlayEnabled = $('.slideshow__slides', this.$container).data('slideshow-transition');

    this.$container.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
    this.$container.on('slideshow_mobile_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: function() {
    var $container = this.$container;

    if (this.autoPlayEnabled) {
      setInterval(function() {
        var $slide = $('.slideshow__slide--active', $container).removeClass('slideshow__slide--active');
        var $button = $('.slideshow__button--active', $container).removeClass('slideshow__button--active');
        var $slides = $('.slideshow__slide', $container);
        var currentIndex = ($slides.index($slide) + 1) % $slides.length;
        $slides.eq(currentIndex).addClass('slideshow__slide--active');
        var $buttons = $('.slideshow__button', $container).eq(currentIndex).addClass('slideshow__button--active');
        var $dot = $('.slideshow__indicator--active', $container).removeClass('slideshow__indicator--active');
        var $dots = $('.slideshow__indicator', $container);
        $dots.eq(currentIndex).trigger('click');
      }, this.speed)
    }
  }
};
sections.extend('slideshow-section', slideshowAutoExtension);
